import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import Preloader from "../../Components/Preloader";
import { getVolveConfigurationById, updateVolveConfigurationData,saveVolveConfigurationList, getVolveConfigurationList } from "../../redux/actions/VolveAction";

const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [stateId, setStateId] = useState(null);
  const [roleCode,setroleCode]=useState("JUNIOR_ENGINEER");
  const [fieldErrors, setFieldErrors] = useState(null);

  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    volveReducer: {
        loadingVolveConfiguration,
      errorsVolveConfiguration,
      volveConfigurationLists,
      volveConfigurationById,
      changedVolveConfigurationStatus,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.accessToken && !id) {
      dispatch(getVolveConfigurationList(auth?.accessToken));
    }
  }, [auth?.accessToken, id]);

  useEffect(() => {
    if (id) {
      dispatch(getVolveConfigurationById(auth?.accessToken, id));
    }
  }, [auth?.accessToken, id, dispatch]);


  const [validated, setValidated] = useState(false);

const commandTypeOptions=[
  { value: "Live", label: "Live" },
  { value: "Demo", label: "Demo" },
]



  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
      const updatedPayload = {
        id: id,
        "deviceId": formData?.deviceId,
        "did": formData?.did,
        "valveClosingQuantity": Number(formData?.valveClosingQuantity),
        "name": formData?.name,
        "commandType": formData?.commandType,
        "host": formData?.host,
        "port": Number(formData?.port),
        "topic": formData?.topic,
        "responseTopic": formData?.responseTopic,
        "protocol": formData?.protocol,
        "username": formData?.username,
        "password": formData?.password,
        "clientId": formData?.clientId,
      };
      dispatch(updateVolveConfigurationData(auth?.accessToken, updatedPayload, id));
    }
    else {
      const payload = {
        "deviceId": formData?.deviceId,
        "did": formData?.did,
        "valveClosingQuantity": Number(formData?.valveClosingQuantity),
        "name": formData?.name,
        "commandType": formData?.commandType,
        "host": formData?.host,
        "port": Number(formData?.port),
        "topic": formData?.topic,
        "responseTopic": formData?.responseTopic,
        "protocol": formData?.protocol,
        "username": formData?.username,
        "password": formData?.password,
        "clientId": formData?.clientId,
      };
      dispatch(saveVolveConfigurationList(auth?.accessToken, payload));
    }
  };

  useEffect(() => {
    if (id && volveConfigurationById && typeof volveConfigurationById === 'object' && !Array.isArray(volveConfigurationById)) {
      setFormData({
        deviceId: volveConfigurationById?.deviceId,
        did: volveConfigurationById?.did,
        valveClosingQuantity: volveConfigurationById?.valveClosingQuantity,
        name: volveConfigurationById?.name,
        commandType: volveConfigurationById?.commandType,
        host: volveConfigurationById?.host,
        port: volveConfigurationById?.port,
        topic: volveConfigurationById?.topic,
        responseTopic: volveConfigurationById?.responseTopic,
        protocol: volveConfigurationById?.protocol,
        username: volveConfigurationById?.username,
        password: volveConfigurationById?.password,
        clientId: volveConfigurationById?.clientId,
      });
    }
  }, [id, volveConfigurationById]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsVolveConfiguration && Object.keys(errorsVolveConfiguration).length > 0) {
      if (errorsVolveConfiguration?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsVolveConfiguration?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
                dispatch({ type: 'RESET_DELETE_VOLVE_CONFIGURATION_STATUS' });
      }
      else if (errorsVolveConfiguration?.status === 400) {
        // Handle other status
        if (errorsVolveConfiguration?.data?.errors && Array.isArray(errorsVolveConfiguration.data.errors)) {
          const transformedErrors = {};
          errorsVolveConfiguration.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      }
      else {
        dispatch({ type: 'RESET_DELETE_VOLVE_CONFIGURATION_STATUS' });
      }
      console.log('fieldErrors', fieldErrors);
    }
  }, [errorsVolveConfiguration, dispatch]);

  useEffect(() => {
    if (changedVolveConfigurationStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedVolveConfigurationStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_VOLVE_CONFIGURATION_STATUS' });
      navigate(-1);
    }
  }, [changedVolveConfigurationStatus, dispatch]);

  useEffect(() => {
    if (!id) {
      setFormData({});
    }
    dispatch({ type: 'RESET_DELETE_VOLVE_CONFIGURATION_STATUS' });
  }, [id, dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase();
    setFormData({ ...formData, [name]: processedValue });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler = (selectedData, name) => {
    const selectedId = selectedData[0]?.id;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedId
    }));
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler2 = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData,
    }));
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandlerId = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0]?.id,
    }));
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: fieldErrors.stateId ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: fieldErrors?.stateId ? 'red' : base.borderColor,
      }
    }),
  };

  useEffect(()=>{
    setFieldErrors({})
  },[navigate]);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Volve Configuration"), path: "Volve-Configuration" },
            { label: id ? t("Update Volve Configuration") : t("Add Volve Configuration"), path: "/Add-Volve-Configuration", active: true },
        ]}
        title={id ? t("Update Volve Configuration") : t("Add Volve Configuration")}
      />
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card>
            <Card.Body>
                {errorsVolveConfiguration?.data?.message && (

                <div className="alert alert-danger">
                  {errorsVolveConfiguration?.data?.message}
                </div>
              )}

              <Row>
                <Col lg={6}>
                  <FormInput
                    label={t("Device Id")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.deviceId}
                    name="deviceId"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                
                <Col lg={6}>
                  <FormInput
                    label={t(" DID")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.did}
                    name="did"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Valve Closing Quantity")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.valveClosingQuantity}
                    name="valveClosingQuantity"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.name}
                    name="name"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                <Form.Label>{t("Command Type")}</Form.Label>
                <Select
                  options={commandTypeOptions}
                  values={
                    formData?.commandType
                      ? commandTypeOptions.filter(
                          (opt) =>
                            String(opt.value).toLowerCase() === String(formData.commandType).toLowerCase()
                        )
                      : []
                  }
                  name="commandType"
                  labelField="label"
                  valueField="value"
                  onChange={(selectedData) =>
                    selectHandler2(selectedData[0]?.value, "commandType")
                  }
                  styles={customSelectStyles}
                />
                 {fieldErrors?.commandType && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{fieldErrors?.commandType}</p>
                  </div>
                )}
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Host")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.host}
                    name="host"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    label={t("Response Topic")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.responseTopic}
                    name="responseTopic"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Protocol")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.protocol}
                    name="protocol"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Port")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.port}
                    name="port"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Topic")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.topic}
                    name="topic"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Username")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.username}
                    name="username"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Password")}
                    type="text"
                    errors={fieldErrors}
                    name="password"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Client Id")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.clientId}
                    name="clientId"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

               
              
              </Row>

              <div className="d-flex justify-content-center">
                {loading ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loading && (<Preloader />)}
      {loadingVolveConfiguration && (<Preloader />)}
    </>
  );
};

export default Dashboard;
